import { Helmet } from "react-helmet";
import {
  Autocomplete,
  Box,
  Button,
  Container,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  Menu,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Toolbar,
  Typography,
  Avatar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import personalGoal from "../../assets/images/personal-goal.svg";
import { Navigate } from "react-router";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import Icon from '@mui/material/Icon';
import * as Util from "../../services/global.service";

const useStyles = makeStyles({
  boxLeft: {
    width: "25%",
    "padding-bottom": "25px",
  },
  boxRight: {
    width: "75%",
    "padding-bottom": "25px",
  },
});


const DefaultForm = (props) => {
  const { open, close, data, status } = props
  const classes = useStyles();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  // useEffect(() => {
  //   console.log(data,status, 9994);
  // }, [open]);
  const handleCloseDialog = () => {
    close(false);
  };
  return (
    <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth="md" PaperProps={{ sx: { padding: '30px 30px 15px' } }}>
      <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }} color="#404349">
        Detail
        <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ padding: "0" }}>
        <Box pt="20px" sx={{ display: "flex", "flex-flow": "row wrap" }}>
          <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              File Name:
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={18} fontWeight={500} lineHeight="26.91px" color="#404349">
              {Util.formatData(data?.file_name, "-")}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              Template Type:
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={16} lineHeight="26.91px" color="#404349">
              {Util.formatData(data?.template_type, "-")}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              Cycle:
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={16} lineHeight="26.91px" color="#404349">
              {Util.formatData(data?.cycle, "-")}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              Completed Date:
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={16} lineHeight="26.91px" color={data?.complete_date !== "" ? status === "complete" ? "#5DA196" : "#404349" : "#404349"}>
              {Util.formatData(Util.dateDayTimeFormatAdmin(data?.complete_date, ""), "-")}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              Source Size
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={16} lineHeight="26.91px" color="#404349">
              {Util.formatData(data?.source_size, "-")}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              Total Source:
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={16} lineHeight="26.91px" color="#404349">
              {Util.formatData(data?.total_source, 0)}
            </Typography>
          </Box>
          {/* <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              Import [Success]:
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={16} lineHeight="26.91px" color="#404349">
              {Util.formatData(data?.import_success, 0)}
            </Typography>
          </Box>
          <Box className={classes.boxLeft}>
            <Typography fontSize={16} lineHeight="26.91px" color="#A3A3A3">
              Import [Fail]:
            </Typography>
          </Box>
          <Box className={classes.boxRight}>
            <Typography fontSize={16} lineHeight="26.91px" color={data?.import_fail !== 0 ? "#CC6058" : "#404349"}>
              {Util.formatData(data?.import_fail, 0)}
            </Typography>
          </Box> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
};
export default DefaultForm;
